import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OTHER = "__other__";

/** State + district dropdowns (India) with manual fallback, and pincode. */
export const LocationFields = ({ state, setState, prefix = "parcel" }) => {
  const [geo, setGeo] = useState({});
  const [manualDistrict, setManualDistrict] = useState(false);

  useEffect(() => {
    api.get("/geo/states").then(({ data }) => setGeo(data)).catch(() => setGeo({}));
  }, []);

  const states = Object.keys(geo).sort();
  const districts = geo[state.state] || [];

  useEffect(() => {
    if (state.district && districts.length > 0 && !districts.includes(state.district)) setManualDistrict(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districts.length]);

  return (
    <>
      <div>
        <Label className="label-tiny">State *</Label>
        <Select value={state.state || "none"}
          onValueChange={(v) => { setState({ ...state, state: v === "none" ? "" : v, district: "" }); setManualDistrict(false); }}>
          <SelectTrigger className="mt-2" data-testid={`${prefix}-state-select`}>
            <SelectValue placeholder="Select state" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            <SelectItem value="none">Select state</SelectItem>
            {states.map((s) => <SelectItem key={s} value={s} data-testid={`state-option-${s}`}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label className="label-tiny">District *</Label>
        {manualDistrict || districts.length === 0 ? (
          <Input className="mt-2" data-testid={`${prefix}-district-input`} value={state.district || ""}
            onChange={(e) => setState({ ...state, district: e.target.value })}
            placeholder={state.state ? "Type district name" : "Select a state first"} />
        ) : (
          <Select value={state.district || "none"}
            onValueChange={(v) => {
              if (v === OTHER) { setManualDistrict(true); setState({ ...state, district: "" }); }
              else setState({ ...state, district: v === "none" ? "" : v });
            }}>
            <SelectTrigger className="mt-2" data-testid={`${prefix}-district-select`}>
              <SelectValue placeholder="Select district" />
            </SelectTrigger>
            <SelectContent className="max-h-72">
              <SelectItem value="none">Select district</SelectItem>
              {districts.map((d) => <SelectItem key={d} value={d} data-testid={`district-option-${d}`}>{d}</SelectItem>)}
              <SelectItem value={OTHER}>Other (type manually)</SelectItem>
            </SelectContent>
          </Select>
        )}
      </div>

      <div>
        <Label className="label-tiny">Pincode *</Label>
        <Input className="mt-2" data-testid={`${prefix}-pincode-input`} value={state.pincode || ""}
          onChange={(e) => setState({ ...state, pincode: e.target.value.replace(/\D/g, "").slice(0, 6) })}
          inputMode="numeric" pattern="[0-9]{6}" minLength={6} maxLength={6} required placeholder="500078" />
      </div>
    </>
  );
};

/** Police station jurisdiction block. */
export const PoliceFields = ({ state, setState, prefix = "parcel" }) => (
  <>
    <div>
      <Label className="label-tiny">Police station</Label>
      <Input className="mt-2" data-testid={`${prefix}-police-input`} value={state.police_station || ""}
        onChange={(e) => setState({ ...state, police_station: e.target.value })}
        placeholder="Shamirpet PS" />
    </div>
    <div>
      <Label className="label-tiny">PS phone number</Label>
      <Input className="mt-2" data-testid={`${prefix}-police-phone-input`} value={state.police_station_phone || ""}
        onChange={(e) => setState({ ...state, police_station_phone: e.target.value })}
        placeholder="040-27945100" />
    </div>
    <div className="sm:col-span-2">
      <Label className="label-tiny">PS address</Label>
      <Input className="mt-2" data-testid={`${prefix}-police-address-input`} value={state.police_station_address || ""}
        onChange={(e) => setState({ ...state, police_station_address: e.target.value })}
        placeholder="Shamirpet PS, Karimnagar Highway, Shamirpet, Medchal-Malkajgiri, Telangana 500078" />
    </div>
    <div className="sm:col-span-2">
      <Label className="label-tiny">Jurisdiction notes</Label>
      <Input className="mt-2" data-testid={`${prefix}-police-notes-input`} value={state.police_jurisdiction_notes || ""}
        onChange={(e) => setState({ ...state, police_jurisdiction_notes: e.target.value })}
        placeholder="Falls under Shamirpet PS limits; Medchal Rural circle / SHO contact" />
    </div>
  </>
);
